import React from 'react';

import c from 'classnames';

import '../../../css/images/logos/round-table-logo.scss';
export function RoundTableLogo(props) {
  const roundTableLogoClassName = c(
     'RoundTableLogo',
    { 'RoundTableLogo--iconOnly': props.iconOnly },
    { 'RoundTableLogo--white': props.white },
    { 'RoundTableLogo--color': props.color }
  )

  if (props.iconOnly) {
    return (
      <LogoIconOnly roundTableLogoClassName={ roundTableLogoClassName } className={ props.className } />
    )
  } else {
    return (
      <Logo roundTableLogoClassName={ roundTableLogoClassName } className={ props.className }/>
    )
  }
}

function Logo(props) {
  return (
    <svg className={ `${ props.roundTableLogoClassName } ${ props.className ? props.className : '' }` } viewBox="0 0 852.59 193.9">
      <defs>
        <clipPath id="clip-path" transform="translate(-548.26 -461.82)">
          <path className="cls-1" d="M1367.7,650V621.44L1388.58,650h6.78V610h-7v27.78L1367.88,610h-7.2v40Zm-79-5.52c-8.1,0-13.26-6.24-13.26-14.46s5.16-14.46,13.26-14.46S1302,621.74,1302,630,1296.78,644.48,1288.74,644.48Zm0,6.24c12,0,20.46-8.76,20.46-20.7s-8.46-20.7-20.46-20.7-20.46,8.76-20.46,20.7S1276.74,650.72,1288.74,650.72Zm-71.88-.72V610h-7v40Zm-69.78,0V616.16h12.12V610h-31.26v6.18h12.12V650Zm-87.06.72c11.58,0,17.28-6.6,17.28-16.56V610h-7.08v24c0,6.36-3.54,10.5-10.2,10.5s-10.26-4.14-10.26-10.5V610h-7.08v24.24C1042.68,644.06,1048.38,650.72,1060,650.72Zm-66.9-.72v-6.18H975.48V610h-7v40Zm-96.6-5.52c-8.1,0-13.26-6.24-13.26-14.46s5.16-14.46,13.26-14.46,13.26,6.18,13.26,14.46S904.56,644.48,896.52,644.48Zm0,6.24c12,0,20.46-8.76,20.46-20.7s-8.46-20.7-20.46-20.7-20.46,8.76-20.46,20.7S884.52,650.72,896.52,650.72Zm-85.32,0c10.8,0,15.48-5.7,15.48-12.36,0-14.94-23.28-10.32-23.28-17.76,0-3,2.64-5,6.78-5a16.27,16.27,0,0,1,11.58,4.56l4-5.22c-3.72-3.6-8.76-5.58-15-5.58-8.76,0-14.58,5.1-14.58,11.7,0,14.76,23.34,9.54,23.34,17.94,0,2.64-2.28,5.46-8,5.46A17.26,17.26,0,0,1,798.84,639l-3.9,5.4C798.48,648.14,803.82,650.72,811.2,650.72Z"/>
        </clipPath>
        <clipPath id="clip-path-2" transform="translate(-548.26 -461.82)">
          <rect className="cls-1" width="1920" height="1080"/>
        </clipPath>
        <clipPath id="clip-path-3" transform="translate(-548.26 -461.82)">
          <path className="cls-1" d="M1395.86,581V567.88h-27.74V558h27.12V544.86h-27.12v-9.1h27.74V522.64h-42.79V581Zm-50.58,0V567.88h-23.45V522.64h-15V581Zm-67.81-12.69h-15.14v-10.5h15.14c3.67,0,5.77,2.36,5.77,5.25C1283.24,566.21,1281.06,568.31,1277.47,568.31Zm-.53-23.27h-14.61v-9.71h14.61c3.07,0,5.17,2,5.17,4.81S1280,545,1276.94,545Zm4.47,36c11.46,0,17.15-7.35,17.15-15.84,0-7.35-4.9-13.3-11.12-14.26,5.52-1.23,10-6.12,10-13.39s-5.51-14.87-17.06-14.87h-33.08V581Zm-62.48-21.52h-14.87l7.43-22ZM1197.14,581l2.89-8.4h23l2.89,8.4H1243l-22-58.36H1202l-22,58.36Zm-34.3,0V535.76h16.28V522.64h-47.69v13.12h16.36V581Zm-89.6-13.12h-9.45V535.76h9.54c10.68,0,16.1,7,16.1,16C1089.43,560.44,1083.48,567.88,1073.24,567.88Zm.09,13.12c18.29,0,31.5-11.11,31.5-29.23s-13.21-29.13-31.59-29.13h-24.5V581ZM999,581V547.22L1023.72,581h14.52V522.64h-15.13v32.11l-23.63-32.11H984V581Zm-53,1c18.64,0,27.47-10.24,27.47-24.76V522.64H958.27v34.21c0,6.91-4.2,11.9-12.25,11.9-8.23,0-12.34-5-12.34-11.9V522.64H918.37v34.74C918.37,571.73,927.21,582.05,946,582.05Zm-66.41-13.3c-9.72,0-15.93-7.44-15.93-16.89S869.89,535,879.61,535s15.83,7.36,15.83,16.89S889.23,568.75,879.61,568.75Zm0,13.3c17.85,0,31.15-12.43,31.15-30.19s-13.3-30.19-31.15-30.19-31.24,12.43-31.24,30.19S861.76,582.05,879.61,582.05Zm-59.15-33.77h-11.9V535.76h11.9c3.93,0,7.26,2.28,7.26,6.21C827.72,546.09,824.39,548.28,820.46,548.28ZM808.56,581V561.4h7.7l9.8,19.6h17.23l-11.9-21.44c5.43-1.92,11.64-7.35,11.64-17.5,0-10.85-7.35-19.42-20.3-19.42H793.51V581Z"/>
        </clipPath>
        <clipPath id="clip-path-5" transform="translate(-548.26 -461.82)">
          <path className="cls-1" d="M881.46,496v-6.56H867.59v-4.95h13.57v-6.56H867.59v-4.55h13.87v-6.56H860.07V496Zm-49.29,0V484.27h12.12V496h7.53V466.82h-7.53v10.89H832.17V466.82h-7.52V496Zm-22.25,0V473.38h8.14v-6.56H794.22v6.56h8.18V496Z"/>
        </clipPath>
      </defs>
      <title>
        Asset 1
      </title>
      <g id="Layer_2">
        <g id="Layer_1-2">
          <path className="cls-2" d="M552.7,472.22l131.28-.6,1.12,63.43s-12.34-21.31-33.94-24.68c-20.4-3.18-98.46-1.12-98.46-1.12Z" transform="translate(-548.26 -461.82)"/>
          <path className="cls-2" d="M730,643.89l-131.27.6V584.42s12.44,18,32.82,21.32S730,606.86,730,606.86Z" transform="translate(-548.26 -461.82)"/>
          <path className="cls-3" d="M554.86,644l-.61-131.27,64.65-.11s-22.53,11.33-25.9,32.93c-3.17,20.4-1.12,98.45-1.12,98.45Z" transform="translate(-548.26 -461.82)"/>
          <path className="cls-3" d="M726.52,470.08l.61,131.28-60-1.23s17.86-11.22,21.22-31.59,1.13-98.46,1.13-98.46Z" transform="translate(-548.26 -461.82)"/>
          <path className="cls-4" d="M686.75,557.49a46,46,0,1,1-46-46m46,46V476a6.49,6.49,0,0,0-6.48-6.49h-121a6.49,6.49,0,0,0-6.49,6.49V639a6.49,6.49,0,0,0,6.49,6.49H722.33a6.49,6.49,0,0,0,6.48-6.49V476.71m-88,126.76a46,46,0,1,0-46-46m0,0V639a6.49,6.49,0,0,0,6.49,6.49h121a6.49,6.49,0,0,0,6.48-6.49V476a6.49,6.49,0,0,0-6.48-6.49H559.24a6.49,6.49,0,0,0-6.49,6.49v36.66m88-1.09h-88m88,92h88" transform="translate(-548.26 -461.82)"/>
          
          <g className="cls-5">
            <g className="cls-6">
              <rect className="cls-7" x="241.67" y="142.5" width="610.42" height="51.4"/>
            </g>
          </g>
          <g className="cls-8">
            <g className="cls-6">
              <rect className="cls-9" x="240.24" y="54.86" width="612.35" height="70.37"/>
            </g>
          </g>
          <g className="cls-10">
            <g className="cls-6">
              <rect className="cls-7" x="240.96" width="97.24" height="39.18"/>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

function LogoIconOnly(props) {
  return (
    <svg className={ `${ props.roundTableLogoClassName } ${ props.className ? props.className : '' }` } viewBox="0 0 370.08 370.08">
      <title>
        Asset 3
      </title>
      <g id="Layer_2">
        <g id="Layer_1-2">
          <path className="cls-1" d="M8.89,14.5l262.54-1.21,2.25,126.87S249,97.52,205.8,90.79C165,84.43,8.89,88.55,8.89,88.55Z"/>
          <path className="cls-1" d="M363.44,357.83,100.89,359V238.9s24.9,35.9,65.64,42.63,196.91,2.25,196.91,2.25Z"/>
          <path className="cls-2" d="M13.19,358,12,95.49l129.3-.21s-45.06,22.65-51.79,65.84C83.13,201.92,87.24,358,87.24,358Z"/>
          <path className="cls-2" d="M356.52,10.22l1.21,262.54-120-2.45s35.72-22.44,42.46-63.18,2.24-196.91,2.24-196.91Z"/>
          <path className="cls-3" d="M277,185a91.95,91.95,0,1,1-92-91.95M277,185V22A13,13,0,0,0,264,9H22A13,13,0,0,0,9,22V348.13a13,13,0,0,0,13,13H348.13a13,13,0,0,0,13-13V23.47M185,277a91.95,91.95,0,1,0-91.95-92m0,0V348.13a13,13,0,0,0,13,13H348.13a13,13,0,0,0,13-13V22a13,13,0,0,0-13-13H22A13,13,0,0,0,9,22V95.28M185,93.09H9M185,277H361.1"/>
        </g>
      </g>
    </svg>
  )
}